<template>
  <v-layout align-start>
    <v-flex>
      <div id="app">
        <v-app id="inspire">
          <v-row justify="center">

            <v-container v-if="cargacreditosino==1">
              <v-row>
                <v-col cols="6" sm="6" md="6" class="py-0">
                  <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fecha1" :readonly="fecha1 == 1" label="Fecha de Inicio"
                        prepend-icon="event" v-bind="attrs" v-on="on" solo @click="listar()"></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha1" scrollable locale="es-es" :readonly="fecha1 == 1">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal1 = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog1.save(fecha1), listar()">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="6" sm="6" md="6" class="py-0">
                  <v-dialog ref="dialog" v-model="modal" :return-value.sync="fecha2" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="fecha2" :readonly="fecha2 == 1" label="Fecha Fin" prepend-icon="event"
                        v-on="on" solo></v-text-field>
                    </template>
                    <v-date-picker v-model="fecha2" scrollable locale="es-es" :readonly="fecha2 == 1">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(fecha2), listar()">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                
              </v-row>

                <v-toolbar color="primary" dark>
                  <v-icon>local_shipping</v-icon>
                  <v-spacer></v-spacer>

                  <v-toolbar-title>Cargas</v-toolbar-title>

                  <v-spacer></v-spacer>

                  <v-btn icon @click="mostrarNuevo()">
                    <v-icon>add</v-icon>
                  </v-btn>
                  <v-btn icon @click="reportefleteexcel()">
                    <i class="fas fa-file-excel" dark></i>
                  </v-btn>
                  <v-btn icon @click="reportepdf()">
                    <i class="fas fa-file-pdf" dark></i>
                  </v-btn>

                </v-toolbar>

                <v-list three-line>
                  <template v-for="(item, index) in cargacreditoselect">
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-icon class="grey lighten-1" dark>
                          account_balance
                        </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title> {{ item.clientenombre }}</v-list-item-title>
                        <v-list-item-subtitle class="text"><span class="text--primary">Fecha:</span>
                          {{ item.cargacreditofecha }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="text"><span class="text--primary">Vehiculo:</span>
                          {{ item.vehiculonombre }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="text"><span class="text--primary">Placas:</span>
                          {{ item.vehiculoplacas }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="text"><span class="text--primary">Cargo:</span>
                          {{ item.cargacreditonombrecargo }}</v-list-item-subtitle>

                      </v-list-item-content>

                      <v-list-item-action>
                        <v-row>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="ver(item)">visibility</v-icon>
                          </v-btn>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="editar(item)">edit</v-icon>
                          </v-btn>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="eliminar(item)">delete</v-icon>
                          </v-btn>
                          <v-btn icon v-if="item.fletepagadosino == 0">
                            <v-icon color="grey lighten-1" @click="pagado(item)">attach_money</v-icon>
                          </v-btn>

                          <v-btn icon v-if="item.fletepagadosino == 1">
                            <v-icon color="grey lighten-1" @click="nopagado(item)">cancel</v-icon>
                          </v-btn>

                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="whatsappweb(item)">call</v-icon>
                          </v-btn>
                        </v-row>
                      </v-list-item-action>
                     
                    </v-list-item>
                    <v-divider v-if="index < cargacreditoselect.length - 1" :key="index"></v-divider>
                  </template>
                </v-list>
            </v-container>

            <v-container v-if="cargacreditosino==0">
              <v-col cols="12" sm="10" md="8" lg="12">
                <v-card ref="form">
                  <v-card-text>
                    <v-alert dense type="info">
                      Captura de Credito por QR
                    </v-alert>
                    <v-row>

                   
                    <v-col cols="6" sm="6" md="6" >
                                          <v-autocomplete v-model="buscarvehiculoid" label="Buscar Cliente"
                                            :items="buscarvehiculoselect" item-text="vehiculoplacas"
                                            item-value="vehiculoid" @keydown.tab="vehiculobusca()" 
                                            v-on:blur="vehiculobusca()" outlined ></v-autocomplete>
                                        </v-col>

                                        <v-col cols="6" sm="6" md="6" >
                        <v-text-field v-model="totalcargavehiculo" label="Total de la Carga " outlined
                          type="number"></v-text-field>
                      </v-col>

                    </v-row>
                                        
                    <div align="center">
                      <v-btn color="primary" @click="prender">Prende QR</v-btn>
                      <v-btn color="primary" @click="Cancelar">Cancelar</v-btn>
                    </div>
                  </v-card-text>

                  <v-col cols="12" md="12" align="center" justify="center" v-if="prenderqr">
                    <div> <qrcode-stream  @decode="onDecode" ></qrcode-stream>
                    </div>
                  </v-col>

                  <v-container v-if="imagenopdf == 1">
                    <v-col cols="12" md="12" align="center" justify="center">
                      <v-img :src="imagePreview" aspect-ratio="1.75" max-height="200" contain
                        class="grey darken-4"></v-img>
                    </v-col>

                    <v-row>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-text-field v-model="clientenombre" label="Nombre del Cliente " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculonombre" label="Nombre del Vehiculo " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculoplacas" label="Placas del Vehiculo " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-select v-model="combustibleid" :items="combustibleselect"
                          label="Tipo de Combustible a Cargar" outlined></v-select>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-select v-model="cargacreditocargagastoid" :items="cargacreditocargagasto"
                          label="Carga o Gasto" outlined></v-select>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="cargacreditovale" label="Numero de Vale " outlined
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" align="center" justify="center">
                        <label>
                          <input type="file" id="file" ref="file" accept="image/jpeg, image/pngf"
                            v-on:change="handleFileUpload()" />
                        </label>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" align="center" justify="center">
                      <v-img :src="imagevale" aspect-ratio="1.75" max-height="200" contain
                        class="grey darken-4"></v-img>
                    </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="cargacreditoticket" label="Numero de Ticket " outlined
                          type="number"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" align="center" justify="center">
                        <label>
                          <input type="file" id="file1" ref="file1" accept="image/jpeg, image/pngf"
                            v-on:change="handleFileUpload1()" />
                        </label>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" align="center" justify="center">
                      <v-img :src="imageticket" aspect-ratio="1.75" max-height="200" contain
                        class="grey darken-4"></v-img>
                    </v-col>

                      <v-col cols="12" sm="3" md="3" class="py-0">
                        <v-text-field v-model="cargacreditolitros" label="Litros De La Carga " outlined
                        @keydown.tab="porlitros()" 
                        v-on:blur="porlitros()" 
                          type="number"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="3" md="3" class="py-0">
                        <v-text-field v-model="cargacreditoimporte" label="Importe De La Carga " outlined
                        @keydown.tab="porimporte()" 
                        v-on:blur="porimporte()" 
                          type="number"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-text-field v-model="cargacreditonombrecargo" label="Nombre de Quien Cargo "
                          outlined></v-text-field>
                      </v-col>

                    </v-row>

                    <div align="center">
                      <v-btn color="primary" @click="guardarcargas()">Guardar</v-btn>
                    </div>

                    <v-list three-line>
                      <template>
                        <v-list-item v-for="item in listacargas" :key="item.cargacreditoticket">
                          <v-list-item-avatar>
                            <v-icon class="grey lighten-1" dark>
                              confirmation_number
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title>Vale: {{ item.cargacreditovale }}</v-list-item-title>
                            <v-list-item-subtitle>Ticket: {{ item.cargacreditoticket }}</v-list-item-subtitle>
                            <v-list-item-subtitle>Importe: {{ item.cargacreditoimporte }}</v-list-item-subtitle>
                            <v-list-item-subtitle>Cargo: {{ item.cargacreditonombrecargo }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-row>

                              <v-btn icon>
                                <v-icon color="grey lighten-1" @click="eliminarcarga(item)">delete</v-icon>
                              </v-btn>

                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>

                    <div align="center">

                      <v-btn color="primary" @click="guardar()">Guardar Cargas</v-btn>
                    </div>
                  </v-container>

                </v-card>
              </v-col>
            </v-container>

            <v-container v-if="cargacreditoveredita==1">
              <v-col cols="12" sm="10" md="8" lg="12">
                <v-card ref="form">
                  <v-card-text>
                    <v-alert dense type="info" color="primary">
                      Ver Datos de Credito
                    </v-alert>
                  </v-card-text>

                  <v-container >
                    <v-col cols="12" md="12" align="center" justify="center">
                      <v-img :src="imagePreview" aspect-ratio="1.75" max-height="200" contain
                        class="grey darken-4"></v-img>
                    </v-col>

                    <v-row>

                      <v-col cols="12" sm="12" md="12" class="py-0">
                        <v-text-field v-model="clientenombre" label="Nombre del Cliente " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculonombre" label="Nombre del Vehiculo " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculoplacas" label="Placas del Vehiculo " outlined></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-select v-model="combustibleid" :items="combustibleselect"
                          label="Tipo de Combustible a Cargar" outlined></v-select>
                      </v-col>

                    </v-row>

                    <div align="center">
                      <v-btn color="primary" @click="Cancelar()">Cancelar</v-btn>
                    </div>

                    <v-list three-line>
                      <template>
                        <v-list-item v-for="item in cargacreditodetalleselect" :key="item.cargacreditodetalleid">
                          <v-list-item-avatar>
                            <v-icon class="grey lighten-1" dark>
                              confirmation_number
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title>Vale: {{ item.cargacreditovale }}</v-list-item-title>
                            <v-list-item-subtitle>Ticket: {{ item.cargacreditoticket }}</v-list-item-subtitle>
                            <v-list-item-subtitle>Importe: {{ item.cargacreditoimporte }}</v-list-item-subtitle>
                            <v-list-item-subtitle>Cargo: {{ item.cargacreditonombrecargo }}</v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-row>

                              <v-btn icon>
                                <v-icon color="grey lighten-1" @click="eliminarcarga(item)">delete</v-icon>
                              </v-btn>

                            </v-row>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>

                   
                  </v-container>

                </v-card>
              </v-col>
            </v-container>


          </v-row>
        </v-app>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

export default {
  data() {
    return {
      // Variable
      contrasenia1: "",
      contrasenia2: "",
      valida: 0,
      validamensaje: [],
      decodedText: '',
      prenderqr: false,
      imagenopdf: 0,
      imagePreview: "",
      imagevale: "",
      imageticket: "",
      vehiculonombre: "",
      vehiculoplacas: "",
      combustiblenombre: "",
      clientenombre: "",
      listacargas: [],
      listacargasfotos: [],
      cargacreditovale: "",
      cargacreditoticket: "",
      cargacreditoimporte: "",
      cargacreditonombrecargo: "",
      total: 0,
      vehiculoid: "",
      clienteid: "",
      combustibleid: "",
      combustibleselect: [],
      cargacreditocargagastoid: 1,
      cargacreditocargagasto: [
        { text: "CARGA", value: 1 },
        { text: "GASTO", value: 2 },
        { text: "ACEITE", value: 3 }
      ],
      cargacreditolitros: "",
      cargacreditosino: 1,
      fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      modal: false,
      modal1: false,
      menu: false,
      modal: false,
      cargacreditoselect: [],
      cargacreditoveredita:0,
      cargacreditodetalleselect: [],
      cargacreditodetalleselectwat: [],
      buscarvehiculoid:"",
      buscarvehiculoselect: [],
      totalcargavehiculo:0,
      combustiblecosto:0,
      archivos: [],
      tickets:"",

      
    };
  },

  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },

  computed: {
    resultado() {
      let sumaTotal = 0;
      this.listacargas.forEach(producto => {
        sumaTotal += parseFloat(producto.cargacreditoimporte);
      });
      return sumaTotal; // Output: 45
    }
  },

  created() {
    this.selectgasolinatipo();
    this.listar();
    this.vehiculotodos();
  },


  methods: {


    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/cargacreditos/listar/" + me.fecha1 + "/" + me.fecha2
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.cargacreditoselect = response.data.cargacredito;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listardetalle(item) {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/cargacreditos/listardetalle/" + item.cargacreditoid
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.cargacreditodetalleselect = response.data.cargacreditodetalle;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listardetallewt(cargacreditoid) {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/cargacreditos/listardetalle/" + cargacreditoid
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.tickets="";
          me.cargacreditodetalleselectwat = response.data.cargacreditodetalle;
          me.cargacreditodetalleselectwat.map(function (x) {
          me.tickets=me.tickets+" "+x.cargacreditoticket
      });
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    vehiculotodos() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/vehiculos/listarvehiculos", configuracion)
        .then(function (response) {
          me.buscarvehiculoselect = response.data.vehiculo;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    vehiculobusca() {
      this.vehiculos(this.buscarvehiculoid);
    },


    handleFileUpload() {
     
      this.file = this.$refs.file.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function () {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.showPreview = true;
            this.imagevale = reader.result;
          }
        }.bind(this),
        false
      );

      /*
          Check to see if the file is not empty.
        */
      if (this.file) {
        /*
            Ensure the file is an image file.
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
       
      }
    },

    handleFileUpload1() {
     
     this.file1 = this.$refs.file1.files[0];
     let reader = new FileReader();

     reader.addEventListener(
       "load",
       function () {
         if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
           this.showPreview = true;
           this.imageticket = reader.result;
         }
       }.bind(this),
       false
     );

     /*
         Check to see if the file is not empty.
       */
     if (this.file1) {
       /*
           Ensure the file is an image file.
         */
       if (/\.(jpe?g|png|gif)$/i.test(this.file1.name)) {
         reader.readAsDataURL(this.file1);
       }
      
     }
   },

    mostrarNuevo() {
      this.cargacreditosino = 0
    },

    Cancelar() {
      this.cargacreditosino = 1;
      this.prenderqr = false;
      this.cargacreditoveredita=0;
    },

    porlitros(){
      this.cargacreditoimporte=(parseFloat(this.cargacreditolitros)*parseFloat(this.combustiblecosto)).toFixed(2);
    },

    porimporte(){
      this.cargacreditolitros=(parseFloat(this.cargacreditoimporte)/parseFloat(this.combustiblecosto)).toFixed(2);
    },

    limpiar() {
      this.valida = 0;
      this.decodedText = "";
      this.imagenopdf = 0;
      this.imagePreview = "";
      this.vehiculonombre = "";
      this.vehiculoplacas = "";
      this.combustiblenombre = "";
      this.clientenombre = "";
      this.listacargas = [];
      this.cargacreditovale = "";
      this.cargacreditoticket = "";
      this.cargacreditoimporte = "";
      this.cargacreditonombrecargo = "";
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.contrasenia1) {
        this.validamensaje.push("La Nueva Contraseña esta Vacia");
      }

      if (!this.contrasenia2) {
        this.validamensaje.push("La Confirmacion Nueva Contraseña esta Vacia");
      }

      if (this.contrasenia1 != this.contrasenia2) {
        this.validamensaje.push("Las Contraseñas no son Iguales");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    prender() {
      this.prenderqr = true;
      this.limpiar();
    },

    guardarcargas() {

      if (this.cargacreditocargagastoid == "") {
        this.$swal("No se a Capturado Si Es Carga o Gasto");
        return;
      }

      if (this.cargacreditovale == "") {
        this.$swal("No se a Capturado El Vale");
        return;
      }

      if (this.cargacreditoticket == "") {
        this.$swal("No se a Capturado El Ticket");
        return;
      }

      if (this.cargacreditoimporte == "") {
        this.$swal("No se a Capturado El Importe");
        return;
      }

      if (this.cargacreditolitros == "") {
        this.$swal("No se a Capturado Los Litros");
        return;
      }

      if (this.cargacreditonombrecargo == "") {
        this.$swal("No se a Capturado Quien Cargo");
        return;
      }

      let index = this.listacargas.findIndex(elemento => elemento.cargacreditoticket === this.cargacreditoticket);
      if (index !== -1) {

        this.$swal("Ya se Capturo");
        return;

      }

      this.listacargas.push({
        cargacreditovale: this.cargacreditovale,
        cargacreditoticket: this.cargacreditoticket,
        cargacreditoimporte: this.cargacreditoimporte,
        cargacreditonombrecargo: this.cargacreditonombrecargo,
        combustibleid: this.combustibleid,
        cargacreditocargagasto: this.cargacreditocargagastoid,
        cargacreditolitros: this.cargacreditolitros,
      });

      this.listacargasfotos.push(this.file1)

      this.$swal("Guardado");
      this.cargacreditoticket = "";
      this.cargacreditoimporte = "";
      this.cargacreditolitros = "";

      this.totalcargavehiculo=this.resultado;

    },

    guardar() {

      if (this.cargacreditonombrecargo == "") {
        this.$swal("No se a Capturado Quien Cargo");
        return;
      }

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      // Guardar

      let formData = new FormData(); 
      formData.append('vehiculoid', me.vehiculoid);
      formData.append('clienteid', me.clienteid);
      formData.append('cargacreditonombrecargo', me.cargacreditonombrecargo);
      formData.append('cargacreditototal', me.resultado);
      formData.append('cargacreditovale', me.cargacreditovale);
      formData.append('liquidacionid', 0);
      formData.append('usuarioid', me.$store.state.usuario.usuarioid);
      formData.append('servicioid', 3);
      formData.append('listacargas', JSON.stringify(me.listacargas));
      formData.append('file0', me.file);
      me.listacargasfotos.forEach(file2 => {
      formData.append('file2[]', file2);
      });
      //formData.append('file2[]', me.listacargasfotos);




      
      axios
        .post(
          "api/cargacreditos/crear", formData
          /*{
           ,
            
            vehiculoid: me.vehiculoid,
            clienteid: me.clienteid,
            cargacreditonombrecargo: me.cargacreditonombrecargo,
            cargacreditototal: me.resultado,
            liquidacionid: 0,
            usuarioid: me.$store.state.usuario.usuarioid,
            servicioid: 3,
            listacargas: me.listacargas,
            file0:me.file
            
          }*/,
          configuracion
        )
        .then(function (response) {
          me.limpiar();
          me.$swal("Flete Capturado con Exito");
          me.cargacreditosino = 1;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });



    },

    eliminarcarga(item) {

      let index = this.listacargas.findIndex(elemento => elemento.cargacreditoticket === item.cargacreditoticket);
      if (index !== -1) {
        this.listacargas.splice(index, 1);
        this.totalcargavehiculo=this.resultado;
      }

    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    ver(item){
      this.cargacreditosino=2;
      this.cargacreditoveredita=1;
      this.vehiculos(item.vehiculoid);
      this.listardetalle(item);
    
    },

    onDecode(text) {
      this.limpiar();
      this.jotason = [];
      this.decodedText = text;
      this.jotason = JSON.parse(text);
      this.vehiculos(this.jotason.vehiculoid);
      this.prenderqr = false;
    },

    keepScanning() {
      // Forzar a continuar escaneando llamando a la función nuevamente
      setTimeout(() => {
        this.decodedText = '';
        // Puedes agregar lógica adicional si es necesario
      }, 2000); // Puedes ajustar el tiempo según sea necesario
    }, 

    vehiculos(vehiculoid) {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/vehiculos/listarvehiculosid/" + vehiculoid,
          configuracion
        )
        .then(function (response) {
          me.verfoto(response.data.vehiculo.vehiculoimg);
          me.vehiculoid = response.data.vehiculo.vehiculoid
          me.clienteid = response.data.vehiculo.clienteigas
          me.vehiculonombre = response.data.vehiculo.vehiculonombre
          me.vehiculoplacas = response.data.vehiculo.vehiculoplacas
          me.combustibleid = response.data.vehiculo.combustibleid
          me.clientenombre = response.data.vehiculo.clientenombre
          me.imagenopdf = 1;
          me.combustiblecosto=response.data.vehiculo.combustiblecosto;

          
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    verfoto(vehiculoimg) {
    
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      // Api Guardar
      axios
        .get("api/vehiculos/verfoto/" + vehiculoimg, configuracion)
        .then(function (response) {
          me.imagenopdf = 1;
          me.imagePreview = response.data.image;
        })
        .catch(function (error) {
          console.log(error);
        });


    },


    async  whatsappweb(item) {


      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      urllistar = "api/cargacreditos/listardetalle/" + item.cargacreditoid
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.tickets="";
          me.cargacreditodetalleselectwat = response.data.cargacreditodetalle;
          me.cargacreditodetalleselectwat.map(function (x) {
          me.tickets=me.tickets+"\n"+x.cargacreditoticket+" Litros: "+x.cargacreditolitros+" Importe: "+x.cargacreditoimporte+" Combustible: "+x.combustiblenombre+
          " el dia: "+x.cargacreditofecha+" a la hora: "+x.cargacreditohora
      });

       //return "https://wa.me/52"6751100973"?text=" + this.whatsappmensaje(item);
       const phoneNumber = item.clientetelefono; // Número de teléfono con código de país
      const message = "Buenos dias, "+item.clientenombre+" se Realiza Carga del Vehiculo : "+"\nPlacas: "+item.vehiculoplacas+"\nVale: "+item.cargacreditovale
      +"\nModelo: "+item.vehiculonombre+"\nTotal de: "+item.cargacreditototal+"\ncon los siguientes Tickets: "+me.tickets+"\nLa persona que realizo la carga fue: "+
      item.cargacreditonombrecargo
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");


        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });

     
     



    },





  }
};
</script>